import { DateRenderer } from "../../dateTimeRenderers";
import { TableColumnDef } from "../types";

import styles from "./styles.module.scss";

export function DateColumn<T extends object = {}>(
  { ...params }: TableColumnDef<T>,
): TableColumnDef<T> {
  return {
    enableColumnFilter: false,
    minSize: 50,
    cell: props => {
      const value = props.getValue() as any;
      return <span className={styles.content}><DateRenderer value={value} /></span>;
    },
    ...params,
    meta: {
      excelProps: {
        //todo implement
        //valueModifier:
        numFmt: "mm/dd/yyyy",
        width: 10,
        filterButton: true,
        ...params?.meta?.excelProps,
      },
    },
  };
}
